<template>
  <div id="addresses">
    <h2> {{ translate('visit-our-temples') }}</h2>
    <p> {{ translate('click-the-image') }}</p>
    <a target="_blank"
      href="https://maps.google.com/?q=templo%20iskcon%20floripa">
      <img src="img/addresses.png" alt="addresses-img">
    </a>

    <br>
    <br>
    <hr>

    <h1> {{ translate('check-our-programs') }} </h1>

    <ul id="schedule-list">
      <li>
        <h5>
          {{ translate('monday-to-friday') }}
        </h5>
        <h6>13h - {{ translate('free-lunch') }} </h6>
      </li>
      <li>
        <h5>
          {{ translate('monday-to-thursday') }}
        </h5>
        <h6>19h - {{ translate('meditation-and-philosophy') }} </h6>
      </li>
      <li>
        <h5>
          {{ translate('on-saturday') }}
        </h5>
        <h6>10h - {{ translate('harinam') }} </h6>
        <h6>17h - {{ translate('festival') }} </h6>
      </li>
    </ul>

  </div>
</template>

<script>
  import { eventBus } from '../main.js'
  import mixins from '../assets/mixins.js'
  export default {
    name: 'adresses',
    mixins: [mixins],
    mounted() {
      
      // this.$route.params.lang ? this.lang = this.$route.params.lang : null
      eventBus.$on('updateLanguage', this.setLang)
    },
    computed: {
     /* language() {
        if (this.lang) {
          return this.lang
        } else {
          this.checkLanguage()
        }
        return this.lang */
    },
    data() {
      return {
        lang: null,
      }
    },
    methods: {
      setLang(l) {
        this.lang = l
      },

      translate(section) {
        switch (section) {
          case 'visit-our-temples':
            if (this.language === 'pt')
              return 'Visite nossos projetos'
            else
              return 'Visit our temples'
          case 'click-the-image':
            if (this.language === 'pt')
              return 'Clique na imagem para abrir o mapa'
            else
              return 'Click the image to open the map'
          case 'check-our-programs':
            if (this.language === 'pt')
              return 'Horários dos programas em florianópolis'
            else
              return 'Florianópolis schedule'
          case 'monday-to-thursday':
            if (this.language === 'pt')
              return 'De segunda a quinta'
            else
              return 'Monday to thursday'

          case 'monday-to-friday':
            if (this.language === 'pt')
              return 'De segunda a sexta'
            else
              return 'Monday to friday'

          case 'on-saturday':
            if (this.language === 'pt')
              return 'No sábado'
            else
              return 'On saturday'

          case 'free-lunch':
            if (this.language === 'pt')
              return 'almoço vegetariano (gratuito)'
            else
              return 'Vegetarian lunch (free-of-charges)'

          case 'meditation-and-philosophy':
            if (this.language === 'pt')
              return 'canto do mantra Hare Krishna e palestra filosófica do Bhagavad-gita'
            else
              return 'Mantra Hare Krishna and Bhagavad-gita lecture'

          case 'harinam':
            if (this.language === 'pt')
              return 'Cantar Hare Krishna nas ruas de floripa'
            else
              return 'Chant Hare Krishna on floripa streets'

          case 'festival':
            if (this.language === 'pt')
              return 'Festival Hare Krishna com canto do mantra Hare Krishna e palestra filosófica do Bhagavad-gita'
            else
              return 'Hare Krishna festival with mantra meditation and Bhagavad-gita lecture'
          // 
        }
      },

    },
  }
</script>

<style>
  #schedule-list {
    font-size: 155%;
  }
</style>